module.exports = __webpack_public_path__ + "static/media/md-bowtie.9a611b96.svg";